// ** Mui imports
import { Chip, Stack, Typography } from "@mui/material";

// ** Component imports
import FlagsCategoryChip from "@/components/flags/FlagsCategoryChip.tsx";

// ** Types imports
import type { FlagRead, FlagSummaryRead, ModuleReadListFlag } from "@/types/api/types";

type FlagsChipProps = {
  flag: FlagRead | FlagSummaryRead | ModuleReadListFlag;
  showCategory?: boolean;
  typographyVariant?: "caption" | "body2" | "body1";
  variant?: "default" | "chip";
  size?: "small" | "medium";
}

const FlagsChip = ({
  flag,
  showCategory = true,
  typographyVariant = "body2",
  variant = "default",
  size = "small",
}: FlagsChipProps) => {
  if (variant === "chip") {
    return (
      <Chip
        label={flag.name}
        color="secondary"
        variant="tonal"
        size={size}
      />
    );
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant={typographyVariant}>{flag.name}</Typography>
      {showCategory && (
        <FlagsCategoryChip category={flag.category} size={size} />
      )}
    </Stack>
  );
};

export default FlagsChip;
